import '@/VueWorking/bootstrap';
// import PhoneReplacer from '@/PhoneReplacer.2.1.1.min.js';

jQuery(document).ready(function(){
    $('BODY').on('click', '.is-invalid', function(){
        $(this).removeClass('is-invalid');
    })
    // const exp1 = new PhoneReplacer(jQuery('INPUT[type=tel]'), {
    //     masks: [
    //         ['+7 (DDD) DDD-DD-DD', ['+7', '7']],
    //         ['8 (DDD) DDD-DD-DD', ['8']],
    //         // ['+38 (DDD) DDD-DD-DD', ['+38', '38', '80']],
    //     ],
    //     masksDef: '+7 (DDD) DDD-DD-DD',
    //     placeholder: '_',
    //     addPlaceholder: true
    // });
    const exp2 = new PhoneReplacer(jQuery('INPUT[type=phone]'), {
        masks: [
            ['+7 (DDD) DDD-DD-DD', ['+7', '7']],
            // ['8 (DDD) DDD-DD-DD', ['8']],
            // ['+38 (DDD) DDD-DD-DD', ['+38', '38', '80']],
        ],
        masksDef: '+7 (DDD) DDD-DD-DD',
        placeholder: '_',
        addPlaceholder: true
    });

    // IMAGES DRAG N DROP AND CHANGEd
    // jQuery(document).on('change', 'INPUT.imgPreviewInput', function () {
    //     //console.log('Работа превью');
    //     var usObj = jQuery(this),
    //         input = jQuery(this)[0];
    //     if (input.files && input.files[0]) {
    //         if (input.files[0].type.match('image.*')) {
    //             var reader = new FileReader();
    //             reader.onload = function (e) {
    //                 usObj.parents('.imgPreview').css('background-image', 'url('+e.target.result+')');
    //             }
    //             reader.readAsDataURL(input.files[0]);
    //         } else {
    //             jQuery(this).parents('.imgPreview').css('background-image', config('app.no_image'));
    //             //console.log('ошибка, не изображение');
    //         }
    //     } else {
    //         jQuery(this).parents('.imgPreview').css('background-image', config('app.no_image'));
    //         //console.log('хьюстон у нас проблема');
    //     }
    // });

    jQuery('BODY').on('keypress', 'INPUT.numberInput', function(e){
        var val = jQuery(this).val(),
            list = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '.'];

        //console.log(String.fromCharCode(e.which));
        //console.log(list.indexOf(String.fromCharCode(e.which)));
        if(String.fromCharCode(e.which) == '.'){
            if(val.length <= 0){
                val = '0.';
                jQuery(this).val('0.');
            }
            if(val.indexOf('.') >= 0){
                return false;
            }
        }
        if(list.indexOf(String.fromCharCode(e.which)) < 0){
            return false;
        }
    });

    jQuery('BODY').on('keypress', 'INPUT.numberInputInt', function(e){
        var val = jQuery(this).val(),
            list = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];

        if(list.indexOf(String.fromCharCode(e.which)) < 0){
            return false;
        }
    });

    jQuery('BODY').on('change', 'INPUT.numberInput, INPUT.numberInputInt', function(e){
        var numberText = jQuery(this).val();
        numberText = numberText.replace(/ /, '');
        numberText = parseFloat(numberText);
        if(isNaN(numberText)){
            numberText = 0;
        }
        jQuery(this).val(numberText);
        return false;
    });

    
    /* windowMenu */
    function getMobileMenu(obj){
        var thisObj = obj,
            btnActive = thisObj.hasClass('active'),
            target = thisObj.data('target'),
            targetBtns = thisObj.data('btns'),
            listBtns = jQuery('.'+targetBtns),
            objTarget = jQuery('#'+target);
        if(!btnActive){
            //jQuery('BODY').addClass('blow');
            jQuery('BODY').addClass('modal-open');
            listBtns.addClass('active');
            objTarget.addClass('active');
            objTarget.animate({"opacity": "1"}, 10)
                .find('.contentHeaderMobile').animate({"right": "0px"}, 300)
                .addClass('active');
        } else {
            //jQuery('BODY').removeClass('blow');
            jQuery('BODY').removeClass('modal-open');
            listBtns.removeClass('active');
            objTarget.find('.contentHeaderMobile').animate({"right": "-430px"}, 200);
            objTarget.animate({"opacity": "0"}, 200, function(){jQuery(this).removeClass('active')});
        }
    }
    jQuery('.btnOpenMenu').on('click', function(e){
        var thisObj = jQuery(this);
        getMobileMenu(thisObj)
        return false;
    });
    jQuery('.wrapperHeadMobile').on('click', function(e){
        if(e.target === this){
            var thisObj = jQuery(this).find('.btnOpenMenu');
            getMobileMenu(thisObj)
            return false;
        }
    });
    // jQuery('.wrapperHeadMobile a.getModal').on('click', function(e){
    //     var thisObj = jQuery(this),
    //         thisObjBtn = jQuery(this).parents('.wrapperHeadMobile').find('.btnOpenMenu');
    //     getMobileMenu(thisObjBtn)
    //     //return false;
    // });
    jQuery('.getBody.nav-link').on('click', function(e){
        var thisObj = jQuery(this),
            link = thisObj.attr('href'),
            //target = link.replace(/^\/\?\#/, ''),
            target = thisObj.data('target'),
            blockTarget = typeof target != "undefined" ? jQuery('#'+target) : false;
        jQuery('.btnOpenMenu').click();
        //console.log(target);
        //console.log(typeof blockTarget != "undefined" && blockTarget != false && blockTarget.length > 0);
        if(typeof blockTarget != "undefined" && blockTarget != false && blockTarget.length > 0){
            jQuery('html, body').animate({ scrollTop: (blockTarget.offset().top - 100) }, 1000);
            history.pushState(null, null, link);
            //return false;
        } else {
            window.location.href = link;
        }
        // easeOutCubic
        return false;
    });
    // child menu
    jQuery('.dropdown SPAN.nav-link.dropdown-toggle').on('click', function(e){
        var thisObj = jQuery(this),
            dropdown = thisObj.closest('.dropdown'),
            active = dropdown.hasClass('open');
        if(!active){
            jQuery('.nav .dropdown').removeClass('open');
            dropdown.addClass('open');
        } else {
            dropdown.removeClass('open');
        }
        return false;
    });
    jQuery('BODY').on('click', function(e){
        let activeMenu = jQuery(this).find('.dropdown.open');
        if(activeMenu.length && jQuery(e.target).closest('.dropdown.open').length == 0){
            activeMenu.removeClass('open');
        }
    });
    /* end windowMenu */
    jQuery('BODY').on('click', '.navQuiz .dropQuiz-toggle', function(){
        let thisObj = jQuery(this),
            item = thisObj.closest('.nav-item'),
            drop = thisObj.next('.dropQuiz-menu'),
            isOpen = item.hasClass('open');
        if(!isOpen){
            item.addClass('open');
            drop.addClass('open');
            // runAudio_slide()
        }
    });
    jQuery('BODY').on('click', '.navQuiz .nav-drop-close', function(){
        let thisObj = jQuery(this),
            block = thisObj.closest('.dropQuiz-menu'),
            item = thisObj.closest('.nav-item'),
            isOpen = item.hasClass('open');
        if(isOpen){
            block.removeClass('open');
            item.removeClass('open');
            // runAudio_slide();
        }
    });

});